/**
 * MeleeConeOverlayState — module singleton holding the "draw the melee swing
 * cone" debug toggle. Same React/dev-action → renderer bridge pattern as
 * AggroRangeOverlayState: the dev-tool tick (toggle_melee_cone) writes via the
 * setters; MeleeConeOverlayRenderer reads isMeleeConeOverlayEnabled() each
 * frame and pays nothing while it is false.
 *
 * Why a module singleton + per-frame poll: renderers run outside React (tied to
 * the game loop), so they can't subscribe to React context. The overlay is
 * session-scoped — it initializes from MELEE_CONE_OVERLAY.defaultEnabled (OFF)
 * on every load, so it is always off by default.
 */

import { MELEE_CONE_OVERLAY } from '../../../shared/config/melee-cone-overlay.config';

let enabled = MELEE_CONE_OVERLAY.defaultEnabled;

export function setMeleeConeOverlayEnabled(value: boolean): void {
  enabled = value;
}

export function isMeleeConeOverlayEnabled(): boolean {
  return enabled;
}

/** Flip the overlay; returns the new state (for logging the toggle). */
export function toggleMeleeConeOverlay(): boolean {
  enabled = !enabled;
  return enabled;
}
